export enum AskCopilotDataEventObject {
  PANEL = 'panel',
  POPOVER = 'popover',
  DOCK_BUTTON = 'dock_button',
  SESSION_RESET = 'session_reset',
  THREAD = 'thread',
  INPUT_SEND = 'input_send',
  INPUT_CANCEL = 'input_cancel',
  INPUT_EXIT = 'input_exit',
  INTERACTION_USER_MESSAGE = 'interaction_user_message',
  INTERACTION_RESPONSE_MESSAGE = 'interaction_response_message',
  INTERACTION_RESPONSE_ERROR = 'interaction_response_error',
  INTERACTION_RESPONSE_MESSAGE_TOOLBAR_COPY = 'interaction_response_message_toolbar_copy',
  INTERACTION_RESPONSE_MESSAGE_SOURCES = 'interaction_response_message_sources',
  INTERACTION_RESPONSE_MESSAGE_SOURCES_ITEM = 'interaction_response_message_sources_item',
  INTERACTION_SYSTEM_MESSAGE = 'interaction_system_message',
  INTERACTION_THINKING_STEPS = 'interaction_thinking_steps',
  FEEDBACK = 'feedback',
  FEEDBACK_FORM_SUBMIT = 'feedback_form_submit',
  LEGAL_MESSAGE = 'legal_message',
  LEGAL_MESSAGE_ACCEPT = 'legal_message_accept',
  ASK_USER_OPTION = 'ask_user_option',
  ASK_USER_OPTION_MORE = 'ask_user_option_more',
  SUGGESTED_PROMPT = 'suggested_prompt',
  ARTIFACT = 'artifact',
}
